import ExportedImage from 'next-image-export-optimizer';
import { type ReactNode } from 'react';
import instagramLogoMark from '../../../../../public/img/instagram-logo-mark.png';
import { PageUrl } from '../../../../constants/PageUrl';
import styles from './index.module.scss';

type Props = {
  children?: ReactNode;
};

const InstagramButton = ({ children }: Props) => (
  <a href={PageUrl.INSTAGRAM_ACCOUNT} target="_blank" rel="noopener noreferrer">
    <div className={styles.base}>
      <div className={styles['base-inner']}>
        <ExportedImage src={instagramLogoMark} alt="Instagram" width={40} height={40} placeholder="empty" />
        <div className={styles.text}>
          <p>
            {children ?? (
              <>
                DMからも
                <br />
                受付中
              </>
            )}
          </p>
        </div>
        <div className={styles['add-friend']}>友達追加</div>
      </div>
    </div>
  </a>
);

export default InstagramButton;
